import {
  save, getUpcomingEvents, getEventDetails,getEventRecordings,downloadRecording, downloadFile,downloadMom, uploadFile, importUsers,
  changeEventStatus,changeStreamingStatus,changeRecordingStatus, changeEventVotingStatus, getEventStatus, getEventResult, getPastEvents,
  endVoting, getEventId, getVotingResult, getDetailsFromUUID, submitAttendance, getEventUsers,
  getVotingTypes, deleteEvent, updateEvents, rsvpSendOtp, rsvpVerifyOtp, getOnlyEventDetails,
  getQuorums, logErrors, resetEvent, getEventNotifications, updateEventNotifications, eventMarkAsSpeaker,eventMarkAsSpeakerFromUser, eventHandRaised, eventStartSpeakerTime, saveEventChat, getMessageList, getChatList, updateMuteStatus, getEventVotingHistory, getSpeakerTimer
} from '@/api/event'
import { getUserDataByIds } from '@/api/user'

import Cookies from 'js-cookie'

const event = {
  state: {
    listener: {
      key: null,
      payload: null
    },
    bne_activated: false,
    bne_api: null,
		voting_types: [],
    quorom_types: [],
		is_delegated: false,
		delegated_for: [],
    confirmation_vote: 0,
    user_right_to_vote: false,
    event_voting: [],
    event_name: '',
    event_detail: null,
    event_status: 0,
    participants: [],
    presence_channel: null
  },

	mutations: {
    SET_BNE_API: (state, api) => { state.bne_api = api },
    SET_BNE_ACTIVATED: (state, bne_activated) => { state.bne_activated = bne_activated },
    REMOVE_BNE_API: (state) => {
      state.bne_activated = false;
      if(state.bne_api){
        state.bne_api.removeAllListeners();
        state.bne_api.dispose();
      }
      state.bne_api = null;
    },
    SET_EVENT_STREAMING_STATUS: (state, status) => {
      state.event_detail = { ...state.event_detail, is_streaming_started: Number(status) };
    },
		SET_EVENT_VOTING_TYPES: (state, voting_types) => state.voting_types = voting_types,
		SET_EVENT_QUOROM_TYPES: (state, quorom_types) => state.quorom_types = quorom_types,
		SET_EVENT_DELEGATED_FOR: (state, delegated_for) => {
			state.delegated_for = delegated_for;
		},
		SET_EVENT_IS_DELEGATED: (state, is_delegated) => {
			state.is_delegated = is_delegated;
		},
    SET_EVENT_VOTING: (state, voting) => {
			state.event_voting = voting.map(vote => {
				vote.type = vote.event_id !== undefined ? 'voting' : 'agenda';
				const evote = state.event_voting.find(v => v.id == vote.id);

				// Uncomment below statement when client wants alphabetical order for candidates
				// evote.candidates = (typeof evote.candidates == "undefined" ? [] : evote.candidates)
				// .sort((a,b) => {
				// 	const textA = a.candidate_name.toUpperCase();
				// 	const textB = b.candidate_name.toUpperCase();
				// 	return textA < textB ? -1 : textA > textB ? 1 : 0;
				// });

				return evote ? Object.assign(evote, vote) : vote;
			})
    },
    UPDATE_EVENT_VOTING: (state, vote) => {
      vote.type = vote.event_id !== undefined ? 'voting' : 'agenda'
      state.event_voting = [...state.event_voting, vote]
    },
    SET_EVENT_CONFIRMATION_VOTE: (state, confirmation_vote) => {
      state.confirmation_vote = confirmation_vote
    },
    SET_EVENT_USER_RIGHT_TO_VOTE: (state, user_right_to_vote) => {
      state.user_right_to_vote = user_right_to_vote
    },
    SET_EVENT_DETAIL: (state, event_detail) => {
      state.event_detail = event_detail;
    },
    SET_EVENT_LASTUPDATE: (state, updated_at) => {
      state.event_detail.updated_at = updated_at;
    },
    SET_EVENT_STATUS: (state, event_status) => {
      state.event_detail = { ...state.event_detail, status: event_status };
    },
    SET_EVENT_NAME: (state, event_name) => {
      state.event_name = event_name
    },
    SET_EVENT_PARTICIPANTS: (state, participants) => {
      state.participants = [...participants];
    },
		SET_EVENT_PARTICIPANTS_OFFLINE: (state) => {
			state.participants = state.participants.map(p => {
				p.online = false;
				p.online_count = 0;
				return p;
			})
		},
    SET_EVENT_PARTICIPANT: (state, participant) => {
      state.participants.push(participant);
    },
    UPDATE_EVENT_PARTICIPANT: (state, participant) => {
      state.participants = [...state.participants.map(p => p.user_id == participant.user_id ? participant : p)];
    },
    EVENT_JOIN_PRESENCE: (state, channel) => {
      state.presence_channel = channel;
    },
    UPDATE_EVENT_LISTENER: (state, listener) => {
      state.listener = listener;
    }
  },

  actions: {
    /**
     * Save Event
     * @param commit
     * @param userInfo
     * @returns {Promise<any>}
     * @constructor
     */
    saveEvent({ commit }, eventForm) {
      return new Promise((resolve, reject) => {
        save(eventForm).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    /**
     * Get Upcoming Events
     * @param commit
     * @returns {Promise<any>}
     * @constructor
     */
    GetUpcomingEvents({ commit }) {
      return new Promise((resolve, reject) => {
        getUpcomingEvents().then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * Download File
     * @param commit
     * @param userInfo
     * @returns {Promise<any>}
     * @constructor
     */
    downloadFile({ commit }) {
      return new Promise((resolve, reject) => {
        downloadFile().then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * Download MomFile
     * @param commit
     * @param userInfo
     * @returns {Promise<any>}
     * @constructor
     */
    downloadMom({ commit }, data) {
      return new Promise((resolve, reject) => {
        downloadMom(data).then(response => {
					resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
		/**
     * Download Recording
     * @param commit
     * @param userInfo
     * @returns {Promise<any>}
     * @constructor
     */
    downloadRecording({ commit }, data) {
      return new Promise((resolve, reject) => {
        downloadRecording(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    /**
     * get event details
     * @param commit
     * @param userInfo
     * @returns {Promise<any>}
     * @constructor
     */
    getEventDetails({ commit }, event_id) {
      return new Promise((resolve, reject) => {
        getEventDetails(event_id).then(response => {
          commit('SET_EVENT_VOTING', response.data.data.event_voting);
					delete response.data.data.event_voting;
					commit('SET_EVENT_DETAIL', response.data.data);
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    /**
     * get event recordings
     * @param commit
     * @param userInfo
     * @returns {Promise<any>}
     * @constructor
     */
    getEventRecordings({ commit }, event_id) {
      return new Promise((resolve, reject) => {
        getEventRecordings(event_id).then(response => {
					// commit('SET_EVENT_DETAIL', response.data.data);
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    /**
     * Upload File
     * @param commit
     * @param userInfo
     * @returns {Promise<any>}
     * @constructor
     */
    uploadFile({ commit }, file) {
      return new Promise((resolve, reject) => {
        uploadFile(file).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * import users
     * @param commit
     * @param userInfo
     * @returns {Promise<any>}
     * @constructor
     */
    importUsers({ commit }, data) {
      return new Promise((resolve, reject) => {
        importUsers(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    /**
     * change event status
     * @param commit
     * @param userInfo
     * @returns {Promise<any>}
     * @constructor
     */
    ChangeEventStatus({ commit }, data) {
      return new Promise((resolve, reject) => {
        changeEventStatus(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    ChangeStreamingStatus({ commit }, data) {
      return new Promise((resolve, reject) => {
        changeStreamingStatus(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    ChangeRecordingStatus({ commit }, data) {
      return new Promise((resolve, reject) => {
        changeRecordingStatus(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    async getEventStatus({ commit }, data) {
      const res = await getEventStatus(data);
      if (res.data.status == 'success' && res.data.data) {
        commit('SET_EVENT_CONFIRMATION_VOTE', res.data.data.confirmation_vote);
        commit('SET_EVENT_USER_RIGHT_TO_VOTE', res.data.data.user_right_to_vote);
        // commit('SET_EVENT_DETAIL', res.data.data.event_details);
				commit('SET_EVENT_DELEGATED_FOR', res.data.data.delegated_for);
        if(res.data.data.event_votings && res.data.data.event_votings.length > 0)
				  commit('SET_EVENT_VOTING', res.data.data.event_votings);
				commit('SET_EVENT_IS_DELEGATED', res.data.data.is_delegated);
      }
      return res;
    },

    /**
     * change event  voting status
     * @param commit
     * @param data
     * @returns {Promise<any>}
     * @constructor
     */
    ChangeEventVotingStatus({ commit }, data) {
      return new Promise((resolve, reject) => {
        changeEventVotingStatus(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    getEventResult({ commit }, data) {
      return new Promise((resolve, reject) => {
        getEventResult(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    /**
     * Get Upcoming Events
     * @param commit
     * @returns {Promise<any>}
     * @constructor
     */
    GetPastEvents({ commit }) {
      return new Promise((resolve, reject) => {
        getPastEvents().then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    endVoting({ commit }, data) {
      return new Promise((resolve, reject) => {
        endVoting(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    getEventId({ commit }, data) {
      return new Promise((resolve, reject) => {
        getEventId(data).then(response => {
          commit('SET_EVENT_DETAIL', response.data.data);
          if (response.data.data.event_name) {
            if (response.data.data.is_invitee) {
              commit('SET_EVENT_NAME', response.data.data.event_name)
            }
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    async getSpeakerTimer({ commit }, id) {
      return getSpeakerTimer(id)
    },

    getVotingResult({ commit }, data) {
      return new Promise((resolve, reject) => {
        getVotingResult(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetDetailsFromUUID({ commit }, uuid) {
      return new Promise((resolve, reject) => {
        getDetailsFromUUID(uuid).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    SubmitAttendance({ commit }, data) {
      return new Promise((resolve, reject) => {
        submitAttendance(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    async GetEventUsers({ commit }, event_id) {
      const response = await getEventUsers(event_id);
      const participants = response.data.data
        .map((p, idx) => {
          p.online = false;
          p.online_count = 0;
          if (p.hand_raised)
            p.hand_raised = (new Date(p.hand_raised)).getTime();
          return p;
        });
      commit('SET_EVENT_PARTICIPANTS', participants);
      return response;
    },
    async ParticipantLeavePresence({ state, commit }, { event_id, clearAll }) {
      window.Echo.leave("event." + event_id);
      await commit('EVENT_JOIN_PRESENCE', null);
      if (clearAll)
        await commit('SET_EVENT_PARTICIPANTS', []);
    },
    async getParticipantById({state}, participant_id) {
      const p = state.participants.find((p) => participant_id == p.user_id);
      if(p)
        return p;
      throw new Error('Unable to find participant with id ' + participant_id);
    },
    async ParticipantJoinPresence({ commit, state, dispatch }, event_id) {
      await dispatch('ParticipantLeavePresence', { event_id, clearAll: false });

      const eventPresenceChannel = window.Echo.join("event." + event_id)
        .here((user_infos) => {
          console.log(user_infos);
          state.participants.forEach((participant) => {
            const filter_user_infos = user_infos.filter(user_info => participant.user_id == user_info.user_id);
            if (filter_user_infos.length > 0) {
              participant.online_count = filter_user_infos.length;
              participant.online = true;
              commit('UPDATE_EVENT_PARTICIPANT', participant);
            }
          });

          const adminIds = user_infos.filter(ui => ui.user_role == 'admin' || ui.user_role == 'admin_observer').map(ui => ui.user_id);
          if(adminIds.length > 0) dispatch('AddAdminToEvent', { event_id, adminIds });
        })
        .joining(user_info => {
          dispatch('getParticipantById', user_info.user_id)
          .then(participant => {
            participant.online = true;
            participant.online_count++;
            commit('UPDATE_EVENT_PARTICIPANT', participant);
          })
          .catch(e => {
            dispatch('AddAdminToEvent', { adminIds: [user_info.user_id] })
          })
        })
        .leaving(user_info => {
          dispatch('getParticipantById', user_info.user_id)
          .then(participant => {
            participant.online_count--;
            participant.online = participant.online_count > 0;
            commit('UPDATE_EVENT_PARTICIPANT', participant);
          })
        })
        .listen("EventMarkAsSpeaker", (response) => {
          dispatch('getParticipantById', response.data.user_id)
          .then(participant => {
            participant.is_speaker = response.data.is_speaker;
            commit('UPDATE_EVENT_PARTICIPANT', participant);
          });
        })
        .listen("EventUserHandRaised", (response) => {
          console.log('EventUserHandRaised', response);
          dispatch('getParticipantById', response.data.user_id)
          .then(participant => {
            if (response.data.hand_raised) 
              participant.hand_raised = new Date(response.data.hand_raised).getTime();
            else if (!response.data.hand_raised) 
              participant.hand_raised = null;
            commit('UPDATE_EVENT_PARTICIPANT', participant)
          });
        })
        .listen("EventSpeakerTimerUpdate", (response) => {
          commit('UPDATE_EVENT_LISTENER', {
            key: 'EventSpeakerTimerUpdate',
            payload: response.data
          });
        })
        .listen("EventChatMessage", (response) => {
          commit('UPDATE_EVENT_LISTENER', {
            key: 'EventChatMessage',
            payload: response.data
          });
        })
        .listen("EventMuteUnmute", (response) => {
          dispatch('getParticipantById', response.data.user_id)
          .then(participant => {
            participant.is_muted = response.data.is_muted;
            commit('UPDATE_EVENT_PARTICIPANT', participant)
          })
          commit('UPDATE_EVENT_LISTENER', {
            key: 'EventMuteUnmute',
            payload: response.data
          });
        })
        .listen('EventSpeakerBlockUnmute', response => {
          dispatch('getParticipantById', response.data.user_id)
          .then(participant => {
            participant.block_unmute = response.data.block_unmute;
            commit('UPDATE_EVENT_PARTICIPANT', participant);
          })
        })
        .listen("EventStatus", (response) => {	
          commit('SET_EVENT_STATUS', response.data.status);
          commit('SET_EVENT_LASTUPDATE', response.data.last_updated_at);
          commit('UPDATE_EVENT_LISTENER', {
            key: 'EventStatus',
            payload: response.data
          });
        })
				.listen('EventVotingTimerUpdate', response => {
          commit('UPDATE_EVENT_LISTENER', {
            key: 'EventVotingTimerUpdate',
            payload: response.data
          });
				})
        .listen('EventStreamingStatusUpdated', response => {
          console.log(response);
          commit('SET_EVENT_STREAMING_STATUS', response.data.status);
				})
        .listen('EventVotingStatusChanged', response => {
          commit('UPDATE_EVENT_LISTENER', {
            key: 'EventVotingStatusChanged',
            payload: response.data
          });
        });	

      commit('EVENT_JOIN_PRESENCE', eventPresenceChannel);
    },

    async AddAdminToEvent({ commit, state }, { adminIds }) {
      const response = await getUserDataByIds({ user_ids: adminIds })
      if (response.data.status == 'success') {
				const exist_participants = state.participants.filter(p => adminIds.indexOf(p.user_id) < 0)
        const admins = response.data.data.map(admin => {
          admin.online_count = 1;
          admin.online = true;
          admin.user_id = admin.id;
          return admin;
        });
        commit('SET_EVENT_PARTICIPANTS', [...exist_participants, ...admins])
      }
    },

    GetVotingTypes({ commit }, event_id) {
      return new Promise((resolve, reject) => {
        getVotingTypes(event_id).then(response => {
					commit('SET_EVENT_VOTING_TYPES', response.data.data.voting_types)
					commit('SET_EVENT_QUOROM_TYPES', response.data.data.quorums);
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    DeleteEvent({ commit }, event_id) {
      return new Promise((resolve, reject) => {
        deleteEvent(event_id).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    UpdateEvent({ commit }, event_data) {
      return new Promise((resolve, reject) => {
        updateEvents(event_data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    RsvpSendOtp({ commit }, data) {
      return new Promise((resolve, reject) => {
        rsvpSendOtp(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    RsvpVerifyOtp({ commit }, data) {
      return new Promise((resolve, reject) => {
        rsvpVerifyOtp(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    getQuorums({ commit }, data) {
      return new Promise((resolve, reject) => {
        getQuorums(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    LogErrors({ commit }, error) {
      return new Promise((resolve, reject) => {
        logErrors(error).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    getOnlyEventDetails({ commit }, data) {
      return new Promise((resolve, reject) => {
        getOnlyEventDetails(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    resetEvent({ commit }, data) {
      return new Promise((resolve, reject) => {
        resetEvent(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    GetEventNotifications({ commit }, data) {
      return new Promise((resolve, reject) => {
        getEventNotifications(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    UpdateEventNotifications({ commit }, data) {
      return new Promise((resolve, reject) => {
        updateEventNotifications(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    async eventMarkAsSpeaker({ commit }, data) {
      return eventMarkAsSpeaker(data.event_id, data);
    },

    async eventMarkAsSpeakerFromUser({ commit }, data) {
      return eventMarkAsSpeakerFromUser(data.event_id, data);
    },

    async eventHandRaised({ commit }, data) {
      return eventHandRaised(data.event_id, data);
    },

    async eventStartSpeakerTime({ commit }, data) {
      return eventStartSpeakerTime(data.event_id, data);
    },

    async saveEventChat({ commit }, data) {
      return saveEventChat(data);
    },

    getMessageList({ commit }, data) {
      return new Promise((resolve, reject) => {
        getMessageList(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    getChatList({ commit }, data) {
      return new Promise((resolve, reject) => {
        getChatList(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    updateMuteStatus({ commit }, data) {
      return new Promise((resolve, reject) => {
        updateMuteStatus(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    GetEventVotingHistory({ commit }, data) {
      return new Promise((resolve, reject) => {
        getEventVotingHistory(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
  },

  getters: {
    event_listener: state => state.listener,
    event_detail: state => {
      return state.event_detail;
    },
    myself: (state, getters, rootState, rootGetter) => {
      return rootGetter.currentUser
    },
    event_status(state, getters) {
      if(state.event_detail)
        return state.event_detail.status;
      return 0;
    },
    isHandRaised(state, getters) {
			return state.participants.findIndex(p => p.user_id == getters.myself.id && p.hand_raised !== null) > -1;
		},
    isModeratorOrAdmin: (state, getters) => {
			return getters.myself && (getters.isAdmin || getters.isModerator);
    },
    isSpeaker: (state, getters) => {
      return state.participants
        .findIndex(p => p.user_id == getters.myself.id && p.is_speaker == 1) > -1;
    },
    isModerator: (state, getters) => {
      return state.participants
        .findIndex(p => p.user_id == getters.myself.id && p.is_moderator == 1) > -1;
    },
    participants: (state) => {
      return state.participants;
    }
  }
}

export default event
